import React from 'react'

import { Formik } from 'formik'

import { AdminContext } from 'contexts/AdminContext'
import { ZariContext } from '_zari/context'

import { Form, Button, Row, Col } from '_zari/core'
import Yup from '_zari/validation/_yup'

import { MonedasConstant } from 'constants/index'

import * as BackgroundJobsService from 'services/backgroundJobs.service'

import * as FormGroups from './formGroups'

export const ValidationSchema = Yup.object().shape({
  desdeMes: Yup.string().length(2).required(),
  hastaMes: Yup.string().length(2).required(),
  // mes: Yup.string().length(2).required(),
  moneda: Yup.string().required()
})

const Formato5p1 = () => {
  const __adminContext = React.useContext(AdminContext)
  const __zariContext = React.useContext(ZariContext)
  const [cuentaContableInfo, setCuentaContableInfo] = React.useState('')
  const [flagTodasCuentas, setFlagTodasCuentas] = React.useState(false)

  const formInitialValues = React.useMemo(() => {
    return {
      desdeMes: __adminContext.mesTrabajo || '',
      hastaMes: __adminContext.mesTrabajo || '',
      moneda: MonedasConstant.SOLES,
      cuentaContableAltoBajo: '',
      cuentaContableDesde: '',
      cuentaContableHasta: ''
    }
  }, [__adminContext])

  const onSubmit = React.useCallback(
    async formData => {
      if (__adminContext.flagAltoBajo) {

      } else {
        if (flagTodasCuentas) {
          formData.cuentaContableDesde = ''
          formData.cuentaContableHasta = ''
        } else {
          if (!formData.cuentaContableDesde || !formData.cuentaContableHasta) {
            __zariContext.snack('error', 'Ingresar rango de cuentas contables.')
            return
          }

          if (`${formData.cuentaContableDesde}`.length !== `${formData.cuentaContableHasta}`.length) {
            __zariContext.snack('error', 'Las cuentas contables ingresadas deben ser del mismo nivel.')
            return
          }
        }
      }
      await BackgroundJobsService.iniciarReporteLibroMayor(formData)
        .then(() => {
          __zariContext.snack('info', 'Reporte de libro mayor enviado a procesos en background.')
        })
        .catch(({ data }) => __zariContext.snack('error', data?.error || 'No se pudo iniciar el proceso.'))
    },
    [__zariContext, flagTodasCuentas, __adminContext]
  )

  return (
    <>
      {__adminContext.mesTrabajo && (
        <Formik initialValues={formInitialValues} validationSchema={ValidationSchema} onSubmit={onSubmit}>
          {({ errors, touched, isSubmitting, handleSubmit, handleBlur, setFieldValue, values }) => (
            <Form>
              <Row>
                <Col md={6}>
                  <FormGroups.MesContabilidadFormGroup
                    idFormato='libroMayor-mes'
                    name='desdeMes'
                    label='DESDE MES'
                    iError={errors.desdeMes}
                    iTouched={touched.desdeMes}
                    fIsSubmitting={isSubmitting}
                  />
                  <FormGroups.MesContabilidadFormGroup
                    idFormato='libroMayor-hasta'
                    name='hastaMes'
                    label='HASTA MES'
                    iError={errors.hastaMes}
                    iTouched={touched.hastaMes}
                    fIsSubmitting={isSubmitting}
                  />
                  <FormGroups.MonedaFormGroup
                    iError={errors.moneda}
                    iTouched={touched.moneda}
                    fIsSubmitting={isSubmitting}
                  />
                  {!__adminContext.flagAltoBajo && (
                    <FormGroups.FlagTodasCuentasFormGroup
                      checked={flagTodasCuentas}
                      onChange={() => setFlagTodasCuentas(prev => !prev)}
                    />
                  )}
                  {__adminContext.flagAltoBajo && (
                    <FormGroups.CuentaContableAltoBajoFormGroup
                      setFieldValue={setFieldValue}
                      iValue={values.cuentaContableAltoBajo}
                      setCuentaInfo={setCuentaContableInfo}
                      cuentaContableInfo={cuentaContableInfo}
                    />
                  )}
                  {!__adminContext.flagAltoBajo && !flagTodasCuentas && (
                    <>
                      <FormGroups.CuentaContableDesdeFormGroup
                        iError={errors.cuentaContableDesde}
                        iTouched={touched.cuentaContableDesde}
                        fIsSubmitting={isSubmitting}
                        handleBlur={handleBlur}
                        setFieldValue={setFieldValue}
                      />
                      <FormGroups.CuentaContableHastaFormGroup
                        iError={errors.cuentaContableHasta}
                        iTouched={touched.cuentaContableHasta}
                        fIsSubmitting={isSubmitting}
                      />
                    </>
                  )}
                  <Row>
                    <Col md={12} className='text-right'>
                      <Button disabled={isSubmitting} onClick={handleSubmit}>
                        {isSubmitting ? 'Enviando proceso ...' : 'Generar en background'}
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      )}
    </>
  )
}

export default React.memo(Formato5p1)
